/**
 * Permissions utility functions
 */

/**
 * Get the feature IDs of the user
 * @param {Object} user - The user object
 * @returns {Array} The feature IDs of the user
 */
const getUserFeatureIds = (user) => {
    if (user.hasOwnProperty('features')) {
        return user.features.map((feature) => feature.feature_id);
    }
    return [];
};

/**
 * Get the permissions of the user
 * @param {Object} user - The user object
 * @returns {Array} The permissions of the user
 */
const getUserPermissions = (user) => {
    if (user.hasOwnProperty('features')) {
        return user.features.flatMap((feature) => feature.permissions || []);
    }
    return [];
};

/**
 * Check if the user has a feature
 * @param {Object} user - The user object
 * @param {string} featureId - The feature ID
 * @returns {boolean} True if the user has the feature, false otherwise
 */
const hasFeature = (user, featureId) => {
    return getUserFeatureIds(user).includes(featureId);
};

/**
 * Check if the user has a permission
 * @param {Object} user - The user object
 * @param {string} permission - The permission
 * @returns {boolean} True if the user has the permission, false otherwise
 */
const hasPermission = (user, permission) => {
    return getUserPermissions(user).includes(permission);
};

export { getUserFeatureIds, getUserPermissions, hasFeature, hasPermission };
